var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2NewHair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair4_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M585.3,218.3c-1-35.2-12.4-69.8-37.4-95.6c-3.7-4.1-7.6-8.1-11.7-11.9c-26.5-24.6-60.8-50.5-95.7-61.3 c-24.8-9.2-47.9-11.9-68-13c-62-3.4-161.4,34.3-210,95c-5.8,6-11.2,12.3-16.6,18.6c-3.6,4.4-7,8.8-10.3,13.2 c-11.4,15.6-21.2,32.2-29,49.8c-1.9,4.4-3.8,8.9-5.5,13.4c-17.6,47-23.9,106.4,5.2,149.9c1.9,3.4,4.2,6.5,7,9.5 c2.4,2.6,8.5,8.9,12.6,6.6c2.1-1.2,5.7-8.9,7.6-11.2c2.6-3.3,5.8-6.4,8.8-9.5c3-3,6-5.7,8.5-8.5c4.1-4.1,7.4-9.7,7.2-14 c-0.7-21.3,0-38,7-46.7c12-14.9,10.8-15.6,17.3-33.3c7.2-19.6,15-18.7,28-30.7c7.2-6.6,5.7-20.7,7.4-32.7l13.6-1.3 c34.7-23.9,62.9-37.8,107-45c36.5-5.9,86.3-6.7,119.2,10.7c12.3,6.5,26.1,18.3,32.8,30.4c0.3-1.8,0.9-3.6,1.8-5.5l5.1,9.8 c0.3,23.3,13.4,43.6,27.8,61.9c18.3,23.2,11.2,63.7,21.9,70.4c6.6-9.7,11.4-18.8,15.1-27.8c13.6-23.1,21.4-49.1,22.8-76 C585.3,228.4,585.4,223.3,585.3,218.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_9_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M531.2,204.4c4.3-4.7,21.2-19.9,14.2-24.7c-103.5-18.8-210.6-23.4-315.9-10.7c-13.9,1.6-27.7,3.6-41.5,5.8 c-7.8,1.4-15.6,3-23.4,4.7c-1.8,4.6,5,12.5,7.5,15.5c4.6,5.6,9.4,11.5,14.8,16.5c5.9,5.6,13.3,10.4,20.5,10.5 c95.9-21.4,197.6-19.6,295.1-1.5C515.2,220.2,523.4,212.9,531.2,204.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M217.7,170.5c-9.9,1.3-19.9,2.7-29.8,4.3c-7.8,1.4-15.6,3-23.4,4.7c-1.8,4.6,5,12.5,7.5,15.5 c4.6,5.6,9.4,11.5,14.8,16.5c5.9,5.6,13.3,10.4,20.5,10.5c34.8-7.8,70.4-12.5,106.2-14.4C278.5,202.1,242.7,193,217.7,170.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M225.2,74.3c-10.8,28.1-18.6,67.1-19.8,98c8-1.1,16-2.2,24.1-3.1c91.7-11.1,184.8-9,275.8,4.1 c-2.7-36.2-8.7-71.8-20.5-105.4C416.5,48.7,304.1,41.3,225.2,74.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M225.2,74.3c-8.7,22.7-15.5,52.4-18.4,79.3c12.4-2.5,25.1-4.6,38.1-6.4c0.4-27.8,5.2-60,12-83.6 C245.9,66.5,235.3,70.1,225.2,74.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M206.8,153.5c-0.7,6.5-1.2,12.7-1.4,18.7c8-1.1,16-2.2,24.1-3.1c91.7-11.1,184.8-9,275.8,4.1 c-0.4-5.7-0.9-11.4-1.5-17.1C413.7,135.4,300.8,134.7,206.8,153.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M452.1,146.7c-8.8-1.2-17.7-2.3-26.7-3.1l0.8,21.1c9,0.6,18,1.4,26.9,2.3L452.1,146.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2NewHair4);
export default __webpack_public_path__ + "static/media/m-hat2_new-hair4.5b5c8406106a8c31cec1ddd4b63aa391.svg";
export { ForwardRef as ReactComponent };